import { render, staticRenderFns } from "./SelectCustomerType.vue?vue&type=template&id=cee9afb0&scoped=true&"
import script from "./SelectCustomerType.vue?vue&type=script&lang=js&"
export * from "./SelectCustomerType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee9afb0",
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QSelect});
